export default {
  "content": "<path d=\"M31.708 26.774l-13.8-23.688a2.22 2.22 0 00-3.816 0L.292 26.774A2.158 2.158 0 002.2 30h27.6a2.158 2.158 0 001.908-3.226zM16 26a2 2 0 110-4 2 2 0 010 4zm2-8a2 2 0 01-4 0v-6a2 2 0 014 0v6z\" fill=\"#A4A9B6\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};